// for injecting lodash helpers into globals
import { debounce } from "lodash";

window.debounce = debounce;



// WEBPACK FOOTER //
// ./app/javascript/support/lodash.js